import { gql } from '@apollo/client';

export const GET_PUSH_CAMPAIGN_RESULT = gql`
    query GetPushCampaignResult($campaignId: String!) {
        getPushCampaignResult(campaignId: $campaignId) {
            campaignId
            status
            totalUsers
            notificationsSent
            notificationsFailed
            successRate
            startedAt
            completedAt
            errors
        }
    }
`;
